module.exports = new __parcel__URL__("shop_machines_zen_garden.8e0f7592.png").toString();